Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconSyncData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round' stroke='currentColor' stroke-width='2'%3e%3cpath d='M2.93 20.381l.395-5.643 5.643.395M4.922 16.352a9.004 9.004 0 0015.98-1.275M20.128 2l-.493 5.635L14 7.142'/%3e%3cpath d='M19.44 6.935A8.99 8.99 0 0012 3a9 9 0 00-8.076 5.024'/%3e%3c/g%3e%3c/svg%3e",
  iconSyncWidth: 24,
  iconSyncHeight: 24
};